import api from './api';

export const trialAssignmentService = {
  // Get trial assignments
  getTrialAssignments: async (trialId) => {
    try {
      const response = await api.get(`/trials/${trialId}/assignments`);
      return response.data;
    } catch (error) {
      console.error('Error fetching trial assignments:', error);
      throw error;
    }
  },

  // Create trial assignment
  createTrialAssignment: async (trialId, assignmentData) => {
    try {
      const response = await api.post(`/trials/${trialId}/assignments`, assignmentData);
      return response.data;
    } catch (error) {
      console.error('Error creating trial assignment:', error);
      throw error;
    }
  },

  // Delete trial assignment
  deleteTrialAssignment: async (trialId, assignmentId) => {
    try {
      const response = await api.delete(`/trials/${trialId}/assignments/${assignmentId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting trial assignment:', error);
      throw error;
    }
  }
};
